import { render, staticRenderFns } from "./EntrustTable.vue?vue&type=template&id=2f62d7f4&scoped=true"
import script from "./EntrustTable.vue?vue&type=script&lang=js"
export * from "./EntrustTable.vue?vue&type=script&lang=js"
import style0 from "./EntrustTable.vue?vue&type=style&index=0&id=2f62d7f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f62d7f4",
  null
  
)

export default component.exports